import { BaseLayer, BaseLayerProps } from "./base-layer";

export type GeoJsonLayerProps = BaseLayerProps;

export const GeoJsonLayer = ({ layer, source }: GeoJsonLayerProps) => {
  return (
    <BaseLayer
      layer={layer}
      source={{
        ...source,
        type: "geojson",
      }}
    />
  );
};
